import styled from 'styled-components'

export const ForeignObject = styled.foreignObject``

export const Legend = styled.span``
